import $ from "jquery";

// Adds active class to first slide of an element with an id that includes with word "carousel".
$(document).ready(function () {
  $("*[id*=carousel]").each(function () {
    $(this).find(".carousel-item").first().addClass("active");
    $(this).find(".carousel-indicators button").first().addClass("active");
    $(this)
      .find(".carousel-indicators button")
      .first()
      .attr("aria-current", "true");
  });
});
